module.exports = __webpack_public_path__ + "static/media/1.85b0b998.png";